module.exports = "https://static.energy5.com/_next/static/images/whyEnergyImage-c1cf0923489fc63975bd63073a2a481c.jpg";